export default __webpack_public_path__ + "static/media/WaysidePaperPrototype.86aace9e.png";